const { REACT_APP_BASE_URL } = process.env;

export const logout = (token) =>
  new Promise((resolve, reject) => {
    const request = new Request(`${REACT_APP_BASE_URL}/admins/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: "",
      redirect: "follow"
    });

    return fetch(request)
      .then((response) => {
        if (!response.ok) throw response;
        else return response.json();
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });

export const logoutAdvisers = (token) =>
  new Promise((resolve, reject) => {
    const request = new Request(`${REACT_APP_BASE_URL}/advisers/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: "",
      redirect: "follow"
    });

    return fetch(request)
      .then((response) => {
        if (!response.ok) throw response;
        else return response.json();
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });

export const logoutLawyers = (token) =>
  new Promise((resolve, reject) => {
    const request = new Request(`${REACT_APP_BASE_URL}/lawyers/logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: "",
      redirect: "follow"
    });

    return fetch(request)
      .then((response) => {
        if (!response.ok) throw response;
        else return response.json();
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
